
















import { dayjs, DT_FORMAT_INPUT, MONTH_FORMAT } from '../../../src_server/common/momentExtends';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { TableColumn } from '../../components/organisms/CommonTable.vue';
import PaymentOptionalEditDialog from './PaymentOptionalEditDialog.vue';
import { OptionalPaymentDTO } from '../../../src_server/entity/dto/OptionalPaymentDTO';
import { PaymentOptionalService } from '../../biz/remote/PaymentOptionalService';
import { Session } from '../../utils/Session';
import { MessageDialog } from '../../utils/MessageDialog';
@Component({ components: { PaymentOptionalEditDialog } })
export default class PaymentOptionalPage extends Vue {
  private target_month = dayjs().format(MONTH_FORMAT);

  private rows: OptionalPaymentDTO[] = [];

  private cols: TableColumn[] = [
    {
      label: '編集',
      type: 'button',
      width: '100px',
      btnClass: {
        btn: true,
        'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r': true,
      },
      name: 'editButton',
      onclick: async (row: OptionalPaymentDTO) => {
        console.log('editrow ', row);
        await this.editRow(row);
      },
      align: 'right',
      tdClass: { 'fz-sm': true },
    },
    {
      label: 'No',
      name: 'no',
      type: 'seq',
      width: '50px',
    },
    {
      label: 'ニックネーム',
      name: 'user_auth.user_name',
    },
    {
      label: '金額',
      align: 'right',
      tdClass: { 'pr-5': true },
      type: 'currency_original',
      width: '100px',
      name: 'optional_payment.optional_amount',
    },
    {
      label: '日付',
      type: 'date',
      name: 'optional_payment.optional_dt',
    },
    {
      label: '備考',
      name: 'optional_payment.optional_note',
    },
    {
      label: '削除',
      type: 'button',
      btnClass: {
        btn: true,
        'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r': true,
      },
      name: 'claimButton',
      onclick: async (row: OptionalPaymentDTO) => {
        await this.deleteRow(row.optional_payment.optional_payment_id!);
      },
      align: 'middle',
    },
  ];

  added(dto: OptionalPaymentDTO) {
    this.rows.push(dto);
    this.rows = this.rows.sort((a, b) => dayjs(b.optional_payment.optional_dt).diff(dayjs(a.optional_payment.optional_dt)));
  }

  edited(dto: OptionalPaymentDTO) {
    const foundIndex = this.rows.findIndex((p) => p.optional_payment.optional_payment_id === dto.optional_payment.optional_payment_id);
    this.rows[foundIndex] = dto;
  }

  async editRow(row: OptionalPaymentDTO) {
    console.log('optional paymet', row);
    await (this.$refs['PaymentOptionalEditDialog'] as PaymentOptionalEditDialog).showEdit(row);
  }

  async deleteRow(id: number) {
    const isOK = await MessageDialog.confirm(`削除してよろしいですか？`);
    if (isOK) {
      const biz = new PaymentOptionalService();
      await biz.deleteOptionalPayments(id);

      const index = this.rows.findIndex((r) => r.optional_payment.optional_payment_id === id);
      this.rows.splice(index, 1);
    }
  }

  async addData() {
    await (this.$refs['PaymentOptionalEditDialog'] as PaymentOptionalEditDialog).showAdd();
  }

  @Watch('target_month')
  async loadData() {
    const biz = new PaymentOptionalService();
    const start = dayjs(this.target_month).startOf('month');
    const end = dayjs(this.target_month).endOf('month');
    console.log(start, end);
    const response = await biz.getOptionalPayments(Session.getSessionBuildingId(), start.format(DT_FORMAT_INPUT), end.format(DT_FORMAT_INPUT));
    this.rows = response.data;
  }

  async created() {
    await this.loadData();
  }
}
